import React from 'react';
import Service from './Service'; // Assuming Service component is in the same directory
import thumbnail1 from '../../assets/IMG_2465.jpg';
import thumbnail2 from '../../assets/IMG_2879.png';
import thumbnail3 from '../../assets/house_tint_thumbnail.png';
import thumbnail4 from '../../assets/remove_tint_thumbnail.jpg';

// import thumbnail5 from '../../assets/eka.jpg'; // Assuming this is for Solārā Kontrole
// import thumbnail6 from '../../assets/ekasecurity.jpg'; // Assuming this is for Drošības Kontrole
// import thumbnail7 from '../../assets/ekagrafitti.jpg'; // Assuming this is for Pretgrafiti
// import thumbnail8 from '../../assets/ekafrost.jpg'; // Assuming this is for Privātums

const Services = () => {
  return (
    <div id="services" className='bg-gray-800 py-12'>
      <div className='container mx-auto px-4'>
        {/* Section Title */}
        <div className='text-white font-semibold text-3xl text-center mb-8'>
          PAKALPOJUMI
        </div>

        {/* Services Grid */}
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8'>
          {/* Existing Services */}
          <Service
            title='LUKTURU APLĪMĒŠANA'
            price='39-59'
            desc='Cena norādīta par lukturu pāri. Aplīmēšanai tiek izmantota ORACLE lukturu aizsargplēve, kas dod ne tikai aptumšojošu efektu, bet arī aizsargošu kārtu, kura pasargās no bojājumiem, skrapējumiem, akmeņiem un citiem apstākļiem. Pieejams arī Xpel PPF.'
            img={thumbnail1}
          />
          <Service
            title='AUTO LOGU TONĒŠANA'
            price='59-89'
            desc='Cena norādīta par aizmugurējiem auto logiem, kurus pēc LV likumdošanas ļauts tonēt cik tumšus klients vēlas. Pieejams tonējums priekšējiem logiem, vējstiklam, atsevišķiem stikliem. Izmantojam tikai Xpel/3M/ASWF materiālu un izsniedzam garantijas talonu.'
            img={thumbnail2}
            shopLink="/shop?category=automotive"
          />
          <Service
            title='SADZĪVES LOGU TONĒŠANA'
            price='21-38'
            desc='Cena norādīta par m2. Sadzīves logus iespējams nolīmēt spoguļplēvē, matētā plēvē, necaurspīdīgā plēvē (blackout), utt. Tonēšanas izmaksas atkarīgas no materiāla, stikla formas un atgriezuma daudzuma.'
            img={thumbnail3}
            shopLink="/shop?category=residential"
          />
          <Service
            title='AUTO LOGU ATPLĒVOŠANA'
            price='15-25'
            desc='Cena norādīta par aizmugurējiem auto logiem. Atplēvošanas izmaksas atkarīgas no plēves stāvokļa un sarežģītības. Aizmugurējo logu apsildošo elementu funkcija tiek saglabāta.'
            img={thumbnail4}
          />

          {/* New Building Services with generated descriptions */}
          {/* <Service
            title='ĒKU SOLĀRĀ KONTROLE'
            // price='??' // Add price if applicable
            desc='Samaziniet telpu uzkaršanu un atspīdumu ar speciālām plēvēm. Aizsardzība pret UV stariem un uzlabota energoefektivitāte jūsu ēkai.'
            img={thumbnail5}
            shopLink="/shop?category=residential"
          />
          <Service
            title='ĒKU DROŠĪBAS KONTROLE'
            // price='??' // Add price if applicable
            desc='Palieliniet stikla izturību pret triecieniem un ielaušanās mēģinājumiem. Drošības plēves aiztur stikla lauskas, pasargājot cilvēkus un īpašumu.'
            img={thumbnail6}
          />
          <Service
            title='ĒKU PRETGRAFITI RISINĀJUMI'
            // price='??' // Add price if applicable
            desc='Aizsargājiet stiklu un citas gludas virsmas no grafiti, skrāpējumiem un kodināšanas. Bojājuma gadījumā plēvi var viegli nomainīt, nevis visu virsmu.'
            img={thumbnail7}
          />
          <Service
            title='ĒKU PRIVĀTUMU RISINĀJUMI'
            // price='??' // Add price if applicable
            desc='Radiet privātas zonas birojos, mājās vai tirdzniecības telpās. Piedāvājam matētas, dekoratīvas, rakstainas un citas plēves vizuālai izolācijai.'
            img={thumbnail8}
            shopLink="/shop?category=residential"
          /> */}

        </div>
      </div>
    </div>
  );
};

export default Services;